import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function WhyChooseUs() {
  const {
    t
  } = useLanguage();
  return <section id="about" className="py-24 relative overflow-hidden" data-id="element-315">
      <div className="absolute inset-0 bg-cover bg-center opacity-15" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/gSGcZoZKqem1UgjHfg3TaG/roof-storm-damage-and-what-to-do-next.webp")'
    }} data-id="element-316" />
      <div className="absolute inset-0 bg-gradient-to-b from-gray-900/95 via-gray-900 to-gray-900/95" data-id="element-317" />
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-318">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-319">
          {/* Image Side */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full lg:w-1/2 relative" data-id="element-320">
            <div className="relative rounded-sm overflow-hidden shadow-2xl aspect-[4/3] border border-white/10" data-id="element-321">
              <img src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&auto=format&fit=crop&w=1073&q=80" alt="Professional Adjuster inspecting property" className="w-full h-full object-cover" data-id="element-322" />
              <div className="absolute inset-0 bg-brand-dark/20" data-id="element-323"></div>
            </div>

            {/* Floating Badge */}
            <div className="absolute -bottom-8 -right-8 bg-brand-gold text-brand-dark p-6 rounded-sm shadow-xl hidden md:block" data-id="element-324">
              <div className="text-4xl font-black mb-1" data-id="element-325">{t.why.exp1}</div>
              <div className="font-bold uppercase tracking-wider text-sm whitespace-pre-line" data-id="element-326">
                {t.why.exp2}
              </div>
            </div>
          </motion.div>

          {/* Content Side */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full lg:w-1/2" data-id="element-327">
            <h2 className="text-brand-gold font-bold tracking-wider uppercase mb-2" data-id="element-328">
              {t.why.tag}
            </h2>
            <h3 className="text-4xl md:text-5xl font-black text-white mb-6 leading-tight" data-id="element-329">
              {t.why.title}
            </h3>
            <p className="text-lg text-gray-300 mb-8 leading-relaxed" dangerouslySetInnerHTML={{
            __html: t.why.desc
          }} data-id="element-330" />

            <ul className="space-y-4 mb-10" data-id="element-331">
              {t.why.benefits.map((benefit, index) => <li key={index} className="flex items-start gap-3" data-id="element-332">
                  <CheckCircle2 className="text-brand-gold shrink-0 mt-1" size={24} data-id="element-333" />
                  <span className="text-gray-200 font-medium text-lg" data-id="element-334">
                    {benefit}
                  </span>
                </li>)}
            </ul>

            <a href="#contact" className="inline-flex items-center justify-center bg-brand-red hover:bg-brand-darkred text-white px-8 py-4 rounded-sm font-bold text-lg transition-colors shadow-lg shadow-brand-red/20" data-id="element-335">
              {t.why.cta}
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}